import register from '@kpsys/angularjs-register';
import {RecordClipboardService} from './record-clipboard.service';
import {KpRecordClipboardButtonPresenter} from './kp-record-clipboard-button/kp-record-clipboard-button.presenter';
import {KpRecordClipboardPanelPresenter} from './kp-record-clipboard-panel/kp-record-clipboard-panel.presenter';

export default register('portaro.features.record.record-clipboard')
    .service(RecordClipboardService.serviceName, RecordClipboardService)
    .service(KpRecordClipboardButtonPresenter.presenterName, KpRecordClipboardButtonPresenter)
    .service(KpRecordClipboardPanelPresenter.presenterName, KpRecordClipboardPanelPresenter)
    .name();
